import { createSlice } from '@reduxjs/toolkit';
import { isOnSmallScreen, isPWAInstalled } from "../../utils";

function getMobileApp() {
    return isOnSmallScreen() && isPWAInstalled();
}

const runtimeDetails = createSlice({
    name: 'runtimeDetails',
    /*
     * We don't want to dynamically support the resizing down to this view. The responsive website
     * will still function correctly at the smaller size.
     */
    initialState: { isMobileApp: getMobileApp() }
});

export const selectIsMobileApp = (state) => state.runtimeDetails.isMobileApp;

export default runtimeDetails.reducer;